import { TCSFormData } from "pages/GenericOrderDetailsPage/types";
import { useFormContext } from "react-hook-form";

export default function TCSEditForm({
    displayName, 
    currentTCS,
  }: {
    displayName: string;
    currentTCS: number
  }) {
    const { 
      register, 
      watch, 
      formState: { errors } 
    } = useFormContext<TCSFormData>();
  
    return (
      <form className="flex flex-col gap-4">
        <label htmlFor="newTcs" className="text-[14px] font-500 text-[#333333]">
          New TCS charges
        </label>
        
        <div className="flex items-center border border-black/30 rounded-lg px-3 py-2">
          <span className="bg-gray-100 border border-gray-300 rounded-lg text-gray-500 text-[15px] p-3">
            INR
          </span>
          <input
            {...register("tcsValue", {
              required: "TCS charges are required",
              pattern: {
                value: /^[0-9]*$/,
                message: "Please enter a valid amount",
              },
            })}
            id="tcsValue"
            className="flex-grow text-[15px] pl-4 border-none focus:outline-none"
            type="number"
            placeholder="Enter new TCS charges"
          />
        </div>
        {errors.tcsValue && (
          <span className="text-red-500 text-sm">
            {errors.tcsValue.message}
          </span>
        )}
  
        <div className="bg-gray-100 p-2 rounded-md">
          <label htmlFor="currenttcs" className="text-sm font-medium">
            Current TCS:{" "}
            <span className="font-semibold">{currentTCS || 0}</span>
          </label>
        </div>
  
        <div className="flex items-center gap-2">
          <input
            {...register("isChecked", {
              required: "You must confirm the TCS charges",
            })}
            type="checkbox"
            id="tcsConfirmation"
            disabled={!watch("tcsValue")}
            className="w-4 h-4"
          />
          <label htmlFor="tcsConfirmation" className="text-sm">
            I hereby declare the TCS charges are updated as confirmed
            by {displayName}.
          </label>
        </div>
        {errors.isChecked && (
          <span className="text-red-500 text-sm">
            {errors.isChecked.message}
          </span>
        )}
      </form>
    );
  }